import React, { useState } from 'react';
import LectureTable from './lecture_table';

const LectureProfile = (props) => {
  const styles = {
    container: {
      display: 'flex',
      width: '100%',
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  };
  return (
    <div style={{ ...styles.container }}>
      <LectureTable {...props} />
    </div>
  );
};

export default LectureProfile;
